import { IAppConfig, ICanary } from '../types';
import {
  handleJsonResponse,
  handleNoContentResponse,
  handleTextResponse,
} from './fetchHelpers';

export function startCanaryRequest(
  { treatCanaryApiUrl, enableIntermediateGoingToStatus, gwRegion }: IAppConfig,
  canaryVersion: string,
  appName = 'TREAT',
): Promise<ICanary> {
  return handleJsonResponse(
    fetch(`${treatCanaryApiUrl}/canary?gwRegion=${gwRegion}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        canaryVersion: canaryVersion,
        appName: appName,
        isCanaryPreStart: enableIntermediateGoingToStatus,
      }),
    }),
  );
}

export function fullStartCanaryRequest(
  { treatCanaryApiUrl, gwRegion }: IAppConfig,
  uid: string,
) {
  return handleNoContentResponse(
    fetch(`${treatCanaryApiUrl}/canary/${uid}/start?gwRegion=${gwRegion}`, {
      method: 'PATCH',
    }),
  );
}

export function goingToGARequest(
  { treatCanaryApiUrl, gwRegion }: IAppConfig,
  uid: string,
) {
  return handleTextResponse(
    fetch(`${treatCanaryApiUrl}/canary/${uid}/goingToGA?gwRegion=${gwRegion}`, {
      method: 'PATCH',
    }),
  );
}

export function deployToGARequest(
  { treatCanaryApiUrl, gwRegion }: IAppConfig,
  uid: string,
) {
  return handleTextResponse(
    fetch(
      `${treatCanaryApiUrl}/canary/${uid}/deployToGA?gwRegion=${gwRegion}`,
      {
        method: 'PATCH',
      },
    ),
  );
}

export function deployToGAWithInputRequest(
  { treatCanaryApiUrl, gwRegion }: IAppConfig,
  uid: string,
  canaryVersion: string,
) {
  return handleTextResponse(
    fetch(
      `${treatCanaryApiUrl}/canary/${uid}/deployToGA?gwRegion=${gwRegion}`,
      {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ canaryVersion: canaryVersion }),
      },
    ),
  );
}

export function terminateRequest(
  { treatCanaryApiUrl, gwRegion }: IAppConfig,
  uid: string,
) {
  return handleTextResponse(
    fetch(`${treatCanaryApiUrl}/canary/${uid}/terminate?gwRegion=${gwRegion}`, {
      method: 'PATCH',
    }),
  );
}

export function getCanaryRequest(
  { treatCanaryApiUrl, gwRegion }: IAppConfig,
  appName = 'TREAT',
): Promise<ICanary> {
  return handleJsonResponse(
    fetch(`${treatCanaryApiUrl}/canary/apps/${appName}?gwRegion=${gwRegion}`, {
      method: 'GET',
    }),
  );
}
